import { DrawerItem, VectorIcon } from '@mobileTypes'
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { ICON_REGISTRY } from '@mobileConstants'

import { MobilePhoneFrame } from './frames/MobilePhoneFrame'

const defaultItems: (DrawerItem & { icon?: VectorIcon | null })[] = [
  {
    internalId: '',
    label: 'Сменить приложение',
    icon: { size: 24, type: 'MaterialDesignIcons', value: 'swap-horizontal' },
  },
  {
    internalId: '',
    label: 'Выход',
    icon: { size: 24, type: 'MaterialDesignIcons', value: 'logout' },
  },
]

interface MobileDrawerPreviewProps {
  drawerItems: DrawerItem[]
}

export const MobileDrawerPreview = ({ drawerItems }: MobileDrawerPreviewProps) => {
  const resolveIconComponent = (icon?: VectorIcon | null) => {
    if (!icon) return null

    const iconItem = ICON_REGISTRY.find(
      item => item.id === icon.value && item.library === icon.type
    )

    if (!iconItem) return null

    return iconItem.Component
  }

  return (
    <MobilePhoneFrame title='📱 Drawer Preview'>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            width: '75%',
            height: '100%',
            backgroundColor: '#fff',
            boxShadow: '4px 0 12px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <List sx={{ py: 1, flex: 1, overflow: 'auto' }}>
            {[...drawerItems, ...defaultItems].map((item, index) => {
              const icon = item.icon as VectorIcon | null | undefined
              const IconComponent = resolveIconComponent(icon)

              return (
                <ListItem
                  key={index}
                  sx={{
                    py: 1,
                    px: 2,
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                >
                  {IconComponent && icon && (
                    <ListItemIcon sx={{ minWidth: Math.max(32, icon.size ?? 24) }}>
                      <IconComponent
                        size={icon.size ?? 24}
                        color={icon.color ?? undefined}
                      />
                    </ListItemIcon>
                  )}
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: '12px',
                      color: 'rgba(28,28,39,0.68)',
                      fontWeight: 600,
                    }}
                  />
                </ListItem>
              )
            })}
          </List>
        </Box>

        <Box
          sx={{
            flex: 1,
            height: '100%',
            backgroundColor: '#f0f0f0',
          }}
        />
      </Box>
    </MobilePhoneFrame>
  )
}
